import React from "react";
import { Modal, Form, Row, Col, Card, Button, Select } from "antd";
import { EtapeModeleService } from "../../services/EtapeModeleService";
import Toast from "../../helpers/Toast";
import PropTypes from "prop-types";
import { catchError } from "../../services/DaoService";
import style from "./EtapeModeleCreateForm.module.scss";
import { EtapeService } from "../../services/EtapeService";
import CustomFormItem from "../utils/form/CustomFormItem";

const EtapeModeleEditForm = ({
	visible,
	onCancel,
	onUpdate,
	etapeModeles,
	etapeModele,
}) => {
	const [form] = Form.useForm();
	const [creating, setCreating] = React.useState(false);
	const [validationErrors, setValidationErrors] = React.useState({});
	const [etapes, setEtapes] = React.useState([]);

	React.useEffect(() => {
		EtapeService.getInstance()
			.all()
			.then((response) => {
				setEtapes(response.data);
			});
	}, []);

	React.useEffect(() => {
		form.setFieldsValue(etapeModele);
	}, [etapeModele, form]);

	const handleUpdate = () => {
		setCreating(true);
		form
			.validateFields()
			.then((values) => {
				const newEtapeModele = {
					...etapeModele,
					...values,
				};

				EtapeModeleService.getInstance()
					.update(etapeModele.id, newEtapeModele)
					.then((response) => {
						Toast.success(response.message);
						form.resetFields();
						onUpdate(response.data);
					})
					.catch((error) => {
						const errors = error.response.data;
						if (errors.validation && Object.keys(errors?.errors).length) {
							setValidationErrors(errors.errors);
						} else {
							catchError(error);
						}
					})
					.finally(() => {
						setCreating(false);
					});
			})
			.catch(() => {
				setCreating(false);
			});
	};

	return (
		<Modal
			width={"50%"}
			open={visible}
			onCancel={onCancel}
			title='Créer une nouvelle etape modele'
			footer={[
				<>
					<Row gutter={24}>
						<Col>
							<Button
								key='cancel'
								onClick={onCancel}
								className={style.ButtonNew}
							>
								Annuler
							</Button>
						</Col>
						<Col>
							<Button
								key='save-show'
								type='primary'
								loading={creating}
								onClick={() => handleUpdate()}
								className={style.ButtonNew}
							>
								Enregistrer
							</Button>
						</Col>
					</Row>
				</>,
			]}
		>
			<Card style={{ marginBottom: 5 }}>
				<Form
					layout='vertical'
					form={form}
					name='createEtapeModeleForm'
					initialValues={{}}
				>
					<Row gutter={24}>
						<Col xs={24} md={24} lg={24}>
							<CustomFormItem
								label='Etape'
								name='etape_id'
								rules={[
									{
										required: true,
										message: "Veuillez selectionner une étape",
									},
									() => ({
										validator(_, value) {
											if (
												etapeModeles.length === 0 ||
												!etapeModeles.find(
													(em) =>
														em?.etape_id == value &&
														etapeModele?.etape_id != value
												)
											) {
												return Promise.resolve();
											}
											return Promise.reject(
												new Error("Cette étape est deja attribuée au modele")
											);
										},
									}),
								]}
								validationErrors={validationErrors}
								setValidationErrors={setValidationErrors}
							>
								<Select
									style={{
										width: "10rem",
									}}
									placeholder='Selectionner une etape'
								>
									{etapes.map((etape) => (
										<Select.Option key={etape.id} values={etape.id}>
											{etape.nom}
										</Select.Option>
									))}
								</Select>
							</CustomFormItem>
						</Col>
					</Row>
				</Form>
			</Card>
		</Modal>
	);
};

export default EtapeModeleEditForm;

EtapeModeleEditForm.propTypes = {
	visible: PropTypes.bool,
	onUpdate: PropTypes.func,
	onCancel: PropTypes.func,
	modele_id: PropTypes.number,
	etapeModeles: PropTypes.array,
	etapeModele: PropTypes.object,
};
